import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/AdmissionActivity'

export const admissionActivityService = {
    getItem,
    search,
    updateItem,
    saveItem,
    deleteItem,
};

function search(offset, max, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data, showAlert: false })
}

function getItem(id) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'GET', { data : null, showAlert: false })
}

function saveItem(data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', {data});
}

function updateItem(id, data) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', {data});
}

function deleteItem(id, db) {
    return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${db}`, 'DELETE', { })
}